/**
 * Pre-hydration loader (M6 performance), called by `src/client.tsx` BEFORE
 * `hydrateRoot`.
 *
 * The browser bundle only ships what EVERY page needs. Per-document extras are
 * separate chunks that must be present before React hydrates, because the
 * components read them synchronously and the tree has to match the SSR HTML:
 *   - the UI dictionary + catalog index of a non-English locale
 *     (English ships in the entry, so English pages wait for nothing);
 *   - the Clerk runtime, only when the server mounted it (`<html data-clerk>`).
 * All requests run in parallel. A failed chunk never blocks hydration forever:
 * the error is reported and React hydrates anyway (the sources fall back).
 */
import { loadCatalogIndex } from '../../content/catalog-index-source'
import { loadClerkRuntime } from '../../components/clerk-runtime-source'
import { CLERK_MOUNT_ATTRIBUTE } from '../auth/clerk-mount'
import { detectLocaleFromPath } from '../i18n/config'
import { loadDictionary } from '../i18n/dictionary-source'

export async function prepareClientRuntime(): Promise<void> {
  const { locale } = detectLocaleFromPath(window.location.pathname)
  const needsClerk =
    document.documentElement.getAttribute(CLERK_MOUNT_ATTRIBUTE) === '1'
  const results = await Promise.allSettled([
    loadDictionary(locale),
    loadCatalogIndex(locale),
    needsClerk ? loadClerkRuntime() : Promise.resolve(),
  ])
  for (const result of results) {
    if (result.status === 'rejected') {
      console.error('[runtime] pre-hydration chunk failed', result.reason)
    }
  }
}
